const getLastDayInMonth = (month, year) => {
  const date = new Date(year, month, 0);
  const lastDay = date.getDate();
  return lastDay;
};
window.addEventListener('DOMContentLoaded', () => {
  const datePickers = document.querySelectorAll('[data-date-picker]');
  if (datePickers) {
    const setDayPickerValue = (dayPicker, lastDay) => {
      const selectElm = dayPicker.querySelector('select');
      if (!selectElm) return;
      const optionsElm = selectElm.children;
      if (!optionsElm) return;
      const optionsElmArray = Array.from(optionsElm);
      for (let index = optionsElmArray.length; index > 28; index--) {
        if (selectElm.value >= lastDay) {
          selectElm.value = lastDay;
        }
        const option = optionsElmArray[index - 1];
        if (index - 1 <= lastDay) {
          option.style.display = '';
          option.disabled = false;
        } else {
          option.style.display = 'none';
          option.disabled = true;
        }
      }
    };

    const handleYearMonthChange = (yearPicker, monthPicker, dayPicker) => {
      [yearPicker, monthPicker].forEach(picker => {
        const yearSelector = yearPicker.querySelector('select');
        const monthSelector = monthPicker.querySelector('select');

        picker.addEventListener('change', () => {
          const currentYear = yearSelector.value;
          const currentMonth = monthSelector.value;
          const lastDay = getLastDayInMonth(currentMonth, currentYear);
          setDayPickerValue(dayPicker, lastDay);
        });
      });
    };

    Array.from(datePickers).forEach(datePicker => {
      const yearPicker = datePicker.querySelector(
        '[data-dropdown-wrapper=year]'
      );
      if (!yearPicker) return;

      const monthPicker = datePicker.querySelector(
        '[data-dropdown-wrapper=month]'
      );
      if (!monthPicker) return;

      const dayPicker = datePicker.querySelector('[data-dropdown-wrapper=day]');
      if (!dayPicker) return;

      handleYearMonthChange(yearPicker, monthPicker, dayPicker);
    });
  }
});
